export const logAndReturn = (value, ...params) => console.log(value, ...params) || value
